<template>
  <div class="wrapper d-flex align-center">
    <div class="player_container">
      <vime-player controls>
        <vime-hls :config="hlsConfig" version="latest">
          <source :data-src="src" type="application/x-mpegURL" />
        </vime-hls>
      </vime-player>
    </div>
  </div>
</template>

<script>
import { VimePlayer, VimeHls } from '@vime/vue'

export default {
  name: 'VideoPage',

  components: {
    VimePlayer,
    VimeHls
  },
  data() {
    return {
      headerOptions: {
        color: 'primary'
      },
      hlsConfig: {
        xhrSetup: (xhr) => {
          xhr.setRequestHeader(
            'Authorization',
            'Bearer' + localStorage.auth_token_default
          )
        }
      }
    }
  },
  created() {
    this.src = `${process.env.VUE_APP_URL}/video/${this.$route.query.video}/index.m3u8`
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(
    0deg,
    rgba(242, 252, 255, 1) 85%,
    rgba(69, 222, 252, 1) 100%
  );
}
.player_container {
  width: 1280px;
  height: 720px;
  margin: 0 auto;
  max-width: 100vw;
  max-height: 80vh;
}
</style>
